import { Typography } from '@mui/material';
import { MEDICINE_STATUSES } from 'API';
import { useIsDesktop } from 'Hooks';

interface IStatus {
  status: number;
  statusLabel: string;
  endDate?: Date;
}

export const Status = ({ status, statusLabel }: IStatus) => {
  const isDesktop = useIsDesktop();

  const blueStyle = {
    backgroundColor: 'primary.shade_100',
    borderColor: 'primary.shade_200',
  };

  const yellowStyle = {
    backgroundColor: '#FFFCF8',
    borderColor: '#FFEDCE',
  };

  const greenStyle = {
    backgroundColor: '#E0F6EF',
    borderColor: '#B8EAD9',
  };

  const purpleStyle = {
    backgroundColor: 'purple2.shade_100',
    borderColor: 'purple2.shade_200',
  };

  const orangeStyle = {
    backgroundColor: 'orange.shade_100',
    borderColor: 'orange.shade_200',
  };

  let styleColor = blueStyle;

  if (
    status === MEDICINE_STATUSES.OPEN_IN_SYSTEM ||
    status === MEDICINE_STATUSES.WAITING_TO_OPEN_IN_SYSTEM
  ) {
    styleColor = blueStyle;
  } else if (
    status === MEDICINE_STATUSES.REJECTED ||
    status === MEDICINE_STATUSES.SUPERPHARM_PARTIAL_SUPPLY
  ) {
    styleColor = purpleStyle;
  } else if (status === MEDICINE_STATUSES.SUPERPHARM_SUPPLY_STOPPED) {
    styleColor = orangeStyle;
  } else if (
    status === MEDICINE_STATUSES.WING_HANDLING ||
    status === MEDICINE_STATUSES.SUPERPHARM_HANDLING ||
    status === MEDICINE_STATUSES.MANUAL_PRESCRIPTION_THAT_APPROVED_AND_ISSUED
  ) {
    styleColor = yellowStyle;
  } else if (status === MEDICINE_STATUSES.SUPERPHARM_FULL_SUPPLY) {
    styleColor = greenStyle;
  }

  return (
    <Typography
      variant='body5'
      sx={{
        border: '1px solid',
        padding: isDesktop ? '4px 12px' : '1px 4px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: 'max-content',
        borderRadius: '6px',
        ...styleColor,
      }}
    >
      {statusLabel}
    </Typography>
  );
};
